var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGoldOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#FE6634"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 10L25.6942 18.2918H34.4127L27.3593 23.4164L30.0534 31.7082L23 26.5836L15.9466 31.7082L18.6407 23.4164L11.5873 18.2918H20.3058L23 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGoldOrange);
export default __webpack_public_path__ + "static/media/star-gold-orange.3750f2e277e1110cdeed3e17f6b76cee.svg";
export { ForwardRef as ReactComponent };